import { crudActions } from "@/services/CrudActions";

export default {
  ...crudActions("clientes-contactos"),
};
